import { Component } from '@angular/core';

@Component({
  selector: 'ov-suite-layout',
  templateUrl: './auth-layout.component.html',
})
export class AuthLayoutComponent {}
